module.exports = __webpack_public_path__ + "h5/img/user_bg.99f784db.png";